/**
 * The student desk's basket, kept across a reload (audit M10) — per PERSON.
 *
 * sessionStorage is per tab, not per person: on a shared machine the next
 * student to sign in on the same tab inherited the last one's basket and
 * purpose. So the key carries the signed-in user's id, and AuthContext clears
 * every saved basket on sign-out and whenever View As / impersonation changes
 * who is being shown. Its own module so AuthContext can clear it without
 * importing the desk hook.
 */
const PREFIX = 'fiavaion.bookDesk.basket.v2.';

const keyFor = (userId) => `${PREFIX}${userId}`;

/** The saved basket for this person, or null. Never throws. */
export function readSavedBasket(userId, today) {
  if (userId === null || userId === undefined) return null;
  try {
    const raw = window.sessionStorage.getItem(keyFor(userId));
    if (!raw) return null;
    const saved = JSON.parse(raw);
    if (!saved || !Array.isArray(saved.basket)) return null;
    // A window that has slipped into the past is not restored: the basket is
    // re-checked against today's window instead (reconcileBasket).
    const range = saved.range && saved.range.startDate >= today ? saved.range : null;
    return { basket: saved.basket.filter((l) => l && l.id && l.unitId != null), range, purpose: saved.purpose || '' };
  } catch {
    return null;
  }
}

/** Save (or, when empty, forget) this person's basket. Never throws. */
export function writeSavedBasket(userId, value) {
  if (userId === null || userId === undefined) return;
  try {
    if (!value.basket.length) window.sessionStorage.removeItem(keyFor(userId));
    else window.sessionStorage.setItem(keyFor(userId), JSON.stringify(value));
  } catch {
    /* storage full or blocked: the basket simply does not survive a reload */
  }
}

/** Forget every saved basket in this tab — on sign-out and View As changes. */
export function clearSavedBaskets() {
  try {
    const keys = [];
    for (let i = 0; i < window.sessionStorage.length; i += 1) {
      const k = window.sessionStorage.key(i);
      if (k && (k.startsWith(PREFIX) || k === 'fiavaion.bookDesk.basket.v1')) keys.push(k);
    }
    keys.forEach((k) => window.sessionStorage.removeItem(k));
  } catch {
    /* nothing to clear */
  }
}
